import React from "react";
import { Sparkles } from "lucide-react";
import "../Styles/InsightsAIPricing.scss";

const InsightsAIPricing = ({ content }) => {
  const text = content?.text || "Pricing details are coming soon. Stay tuned!";

  return (
    <>
      <div className="page-container">
        {/* <div className="scroll-offset" /> */}
        <p className="label">PRICING</p>
        <div className="coming-soon-card">
          <div className="coming-soon-badge">Coming Soon!</div>

          <div className="plant-icon-container">
            <span>
              <Sparkles size={32} color="#10b981" />
            </span>
          </div>

          <div className="funding-text">
            Explore funding opportunities with{" "}
            <span >Microsoft</span>,{" "}
            <span >IMDA</span> &{" "}
            <span >PSG</span>{" "}
            <span>grants.</span>{" "}
            <p>
              Reach out to know more.
            </p>
          </div>
        </div>
      </div>

      <hr className="section-divider" />
    </>
  );
};


export default InsightsAIPricing;













